/**
 * TRIDOO — Video che partono da soli nelle pagine Kibbu (apertura).
 *
 * Ogni <video class="kb-video-auto"> porta due file: uno per il telefono e
 * uno per il computer. Si carica solo quello dello schermo in uso, parte
 * muto quando è in vista e si ferma quando esce, così non consuma rete e
 * batteria mentre si legge il resto. Chi ha chiesto meno animazioni vede
 * solo la prima immagine e lo avvia col pulsante. Il pulsante pausa c'è
 * sempre: un video in movimento per più di 5 secondi deve potersi fermare.
 */
if (!window.tridooVideoKibbu) {
  window.tridooVideoKibbu = true;

  const computer = window.matchMedia('(min-width: 900px)');
  const menoMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pulsanteDi = (video) => video.parentElement.querySelector('[data-kb-video-pausa]');

  const segnaStato = (video) => {
    const pulsante = pulsanteDi(video);
    if (!pulsante) return;
    const fermo = video.paused;
    pulsante.setAttribute('aria-pressed', fermo ? 'true' : 'false');
    pulsante.setAttribute('aria-label', fermo ? pulsante.dataset.testoPlay : pulsante.dataset.testoPausa);
    pulsante.classList.toggle('is-fermo', fermo);
  };

  // Sul computer senza un video suo resta la foto (lo nasconde il CSS): niente file, niente play.
  // Sul telefono lo stream adattivo, dove il browser lo legge da sé: parte leggero invece dei
  // 4,8 Mbps dell'mp4 1080p, l'unico che Shopify espone nel tema.
  const leggeHls = (video) => !!video.canPlayType && video.canPlayType('application/vnd.apple.mpegurl') !== '';

  const scegliFile = (video) => {
    const src = computer.matches
      ? video.dataset.srcComputer
      : (video.dataset.hlsTelefono && leggeHls(video) ? video.dataset.hlsTelefono : video.dataset.srcTelefono);
    const poster = computer.matches ? video.dataset.posterComputer : video.dataset.posterTelefono;
    if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
    if (!src) {
      if (!video.paused) video.pause();
      return false;
    }
    if (video.dataset.srcAttuale !== src) {
      video.dataset.srcAttuale = src;
      video.src = src;
    }
    return true;
  };

  // Con data-kb-dopo-caricamento il video aspetta la pagina pronta (o 3 secondi al più): così
  // non ruba banda alla foto d'apertura e ai testi, che sono quello che si guarda per primo.
  let paginaPronta = document.readyState === 'complete';

  const prova = (video) => {
    if (video.dataset.fermatoDaUtente === 'true' || menoMovimento.matches || !video._inVista) return;
    if ('kbDopoCaricamento' in video.dataset && !paginaPronta) return;
    if (!scegliFile(video)) return;
    const promessa = video.play();
    if (promessa && promessa.catch) promessa.catch(() => segnaStato(video));
  };

  const osservatore =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (voci) =>
            voci.forEach((voce) => {
              const video = voce.target;
              video._inVista = voce.isIntersecting;
              if (voce.isIntersecting) prova(video);
              else if (!video.paused) video.pause();
            }),
          { threshold: 0.25 }
        )
      : null;

  const prepara = (radice = document) => {
    radice.querySelectorAll('video.kb-video-auto').forEach((video) => {
      if (video.dataset.pronto) return;
      video.dataset.pronto = 'true';
      video.muted = true;
      scegliFile(video);
      ['play', 'pause'].forEach((evento) => video.addEventListener(evento, () => segnaStato(video)));
      segnaStato(video);
      if (osservatore) osservatore.observe(video);
      else {
        video._inVista = true;
        prova(video);
      }
    });
  };

  document.addEventListener('click', (evento) => {
    const pulsante = evento.target.closest && evento.target.closest('[data-kb-video-pausa]');
    if (!pulsante) return;
    const video = pulsante.parentElement.querySelector('video.kb-video-auto');
    if (!video) return;
    if (video.paused) {
      video.dataset.fermatoDaUtente = 'false';
      if (scegliFile(video)) video.play().catch(() => segnaStato(video));
    } else {
      video.dataset.fermatoDaUtente = 'true';
      video.pause();
    }
  });

  // Telefono girato o finestra allargata: cambia file, dallo stesso punto non serve.
  computer.addEventListener('change', () =>
    document.querySelectorAll('video.kb-video-auto').forEach((video) => {
      const andava = !video.paused;
      scegliFile(video);
      if (andava) prova(video);
    })
  );
  menoMovimento.addEventListener('change', () =>
    document.querySelectorAll('video.kb-video-auto').forEach((video) => (menoMovimento.matches ? video.pause() : prova(video)))
  );

  if (!paginaPronta) {
    const via = () => {
      if (paginaPronta) return;
      paginaPronta = true;
      document.querySelectorAll('video.kb-video-auto[data-kb-dopo-caricamento]').forEach(prova);
    };
    window.addEventListener('load', () => setTimeout(via, 200), { once: true });
    setTimeout(via, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepara());
  else prepara();
  document.addEventListener('shopify:section:load', (evento) => prepara(evento.target));
}
